<div class="pagination-control">
  @if(this.paginationControl.pageCount > 1){
    <p-paginator [id]="'pagination-control-'+paginationControl.id"
      styleClass="pagination__paginator-styles"
      class="pagination-control__paginator"
      (onPageChange)="onPageChange($event)"
      [first]="paginationControl.firstPage"
      [rows]="paginationControl.itemsPerPage"
      [totalRecords]="totalRecords"
      [pageLinkSize]="paginationControl.pageLinkSize"
      [showFirstLastIcon]="maxPagesIcon">
      <ng-template pTemplate="firstpagelinkicon">
          <button class="common-button__icon-md-noborder">
            <i class="lf lf-icon-double-arrow-left common-icon__md"></i>
          </button>
      </ng-template>
      <ng-template pTemplate="previouspagelinkicon">
          <button class="common-button__icon-md-noborder">
            <i class="lf-icon-angle-left common-icon__md"></i>
          </button>
          @if(paginationControl.showEllipsisPages && paginationControl.currentPage > paginationControl.pageLinkSize){
            <button class="pagination__button-ellipsis"
              (click)="onEllipsis($event, 'descending')">
              <span class="common-icon__md">...</span>
            </button>
          }
      </ng-template>
      <ng-template pTemplate="nextpagelinkicon">
          @if(paginationControl.showEllipsisPages && paginationControl.currentPage < paginationControl.limitNextEllipsis){
            <button class="pagination__button-ellipsis"
              (click)="onEllipsis($event, 'ascending')">
              <span class="common-icon__md">...</span>
            </button>
          }
          <button class="common-button__icon-md-noborder">
              <i class="lf-icon-angle-right common-icon__md"></i>
          </button>
      </ng-template>
      <ng-template pTemplate="lastpagelinkicon">
        <button class="common-button__icon-md-noborder">
          <i class="lf lf-icon-double-arrow-right common-icon__md"></i>
        </button>
      </ng-template>
    </p-paginator>
  }
  <div class="pagination-control__container-pagination">
    @if(totalRecords > paginationControl.itemsPerPage){
      <div class="pagination-control__container-text-pagination">
        <span class="pagination-control__text-pagination-bold">{{paginationControl.firstPageText}}-{{paginationControl.lastPageText}}</span>
        <span [afTranslate]="'common.of'">_de</span>
        <span>{{totalRecords}}</span>
      </div>
    }@else{
      <div class="pagination-control__container-text-pagination">
        <span class="pagination-control__text-pagination-bold">
          <span [afTranslate]="'common.total'">_Total</span>:
          <span>{{totalRecords}}</span>
        </span>
      </div>
    }
  </div>
</div>

